// Optional: Modify the DashboardHeader.jsx to use AuthContext directly
// instead of relying on sessionStorage and custom events

import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import AlertsDropdown from './AlertsDropdown';
import ProfileImage from '../profile/ProfileImage';
import defaultProfileImage from '../../assets/images/default.png'; // Import the default image
import '../../styles/components/dashboardHeader.css';

const DashboardHeader = ({ toggleSidebar, className = '' }) => {
  const { user, logout } = useAuth();  // Get user from AuthContext directly
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const profileButtonRef = useRef(null);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setDropdownOpen(!dropdownOpen);
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
        profileButtonRef.current && !profileButtonRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  // Add sidebar state to body for CSS selectors
  useEffect(() => {
    // You'll need to add logic here to detect sidebar state
    // and add appropriate classes to body
    const sidebarToggled = localStorage.getItem('sidebarToggled') === 'true';
    document.body.classList.remove('sidebar-expanded', 'sidebar-collapsed');
    document.body.classList.add(sidebarToggled ? 'sidebar-collapsed' : 'sidebar-expanded');

    // Handler to update body classes when sidebar state changes
    const updateBodyClasses = () => {
      const isToggled = localStorage.getItem('sidebarToggled') === 'true';
      document.body.classList.remove('sidebar-expanded', 'sidebar-collapsed');
      document.body.classList.add(isToggled ? 'sidebar-collapsed' : 'sidebar-expanded');
    };

    window.addEventListener('sidebar-toggled', updateBodyClasses);

    return () => {
      window.removeEventListener('sidebar-toggled', updateBodyClasses);
    };
  }, []);

  // Get display name and profile image from the AuthContext user object
  const displayName = user?.FullName || 'User';

  return (
    <nav className={`navbar navbar-expand navbar-light bg-white topbar static-top shadow ${className}`}>
      {/* Sidebar Toggle (Mobile) */}
      <button
        id="sidebarToggleTop"
        className="btn btn-link d-md-none rounded-circle mr-3"
        onClick={toggleSidebar}
        aria-label="Toggle Sidebar Menu"
      >
        <i className="fas fa-bars"></i>
      </button>

      {/* Branding for mobile */}
      <div className="d-flex d-md-none align-items-center">
        <span className="font-weight-bold">PhēnixLoc</span>
      </div>
      

      {/* Right-aligned navbar items */}
      <ul className="navbar-nav">
        {/* Alerts dropdown component */}
        <AlertsDropdown />

        <div className="topbar-divider d-none d-sm-block"></div>

        {/* Nav Item - User Information */}
        <li className="nav-item dropdown no-arrow">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            id="userDropdown"
            role="button"
            onClick={toggleDropdown}
            ref={profileButtonRef}
          >
            <div className="d-flex align-items-center">
              <div className="mr-2 d-none d-lg-block">
                <div className="small" style={{ color: '#6c757d', fontSize: '0.75rem', lineHeight: '1', fontWeight: '400' }}>
                  Welcome,
                </div>
                <div style={{ color: '#3a3b45', fontSize: '0.85rem', lineHeight: '1.2', fontWeight: '600' }}>
                  {displayName}
                </div>
              </div>
              <div className="img-profile-wrapper">
                <ProfileImage
                  version={user?.profileImageVersion}
                  src={user?.profileImage}
                  defaultSrc={defaultProfileImage} // Use the imported default image
                  className="img-profile rounded-circle"
                  alt="Profile"
                />
              </div>
            </div>
          </a>
          {/* Dropdown - User Information */}
          {dropdownOpen && (
            <div
              ref={dropdownRef}
              className="dropdown-menu profile-dropdown shadow animated--grow-in"
              aria-labelledby="userDropdown"
            >
              <Link className="dropdown-item" to="/profile">
                <i className="fas fa-user fa-sm fa-fw mr-2" style={{ color: '#00CC5C' }}></i>
                Profile
              </Link>
              <div className="dropdown-divider"></div>
              <a
                className="dropdown-item"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  logout();
                }}
              >
                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2" style={{ color: '#00CC5C' }}></i>
                Logout
              </a>
            </div>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default DashboardHeader;